import TemplatesTable from './TemplatesTable';

export default TemplatesTable;
